// src/pages/ProfileDetailPage.js (İSİM DÜZELTİLMİŞ VERSİYON)

import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';
import { Helmet } from 'react-helmet-async';

const ProfileDetailPage = () => {
    // DEĞİŞİKLİK: 'id' yerine 'profileId' kullanıyoruz.
    const { profileId } = useParams(); 
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        // DEĞİŞİKLİK: Kontrol edilen ve loglanan değişken artık 'profileId'.
        console.log("Component yüklendi. Alınan ID:", profileId);

        if (!profileId) {
            console.error("URL'de profileId bulunamadı!");
            setError("Profile ID is missing.");
            setLoading(false);
            return;
        }

        const fetchProfile = async () => {
            console.log("fetchProfile fonksiyonu çalıştırılıyor...");
            try {
                // DEĞİŞİKLİK: Firestore'dan belge ararken 'profileId' kullanılıyor.
                const docRef = doc(db, 'professionals', profileId);
                console.log("Firestore belge referansı oluşturuldu:", docRef.path);

                console.log("Veri çekme işlemi (getDoc) başlıyor...");
                const docSnap = await getDoc(docRef);
                console.log("Veri çekme işlemi tamamlandı.");

                if (docSnap.exists()) {
                    console.log("Belge bulundu!", docSnap.data());
                    setProfile({ id: docSnap.id, ...docSnap.data() });
                } else {
                    console.warn("Bu ID ile bir belge bulunamadı!");
                    setError('Profile not found.');
                }
            } catch (err) {
                console.error("!!! VERİ ÇEKME HATASI !!!", err);
                setError('Failed to load profile data. Check the console for more details.');
            } finally {
                console.log("finally bloğu çalıştı, loading durumu false yapılıyor.");
                setLoading(false);
            }
        };

        fetchProfile();
    // DEĞİŞİKLİK: useEffect'in bağımlılığı artık 'profileId'.
    }, [profileId]); 

    // Geri kalan JSX kısmı aynı, burada bir değişiklik yok.
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container text-center py-5">
                <div className="alert alert-danger">{error}</div>
                <Link to="/directory" className="btn btn-primary mt-3">Back to Directory</Link>
            </div>
        );
    }

    if (!profile) {
        return <div className="container text-center py-5"><p>No profile data available.</p></div>;
    }

    return (
        <>
            <Helmet>
                <title>{`${profile.name} | Publishing Professionals`}</title>
                <meta name="description" content={`Profile page for ${profile.name}, a professional in the ${profile.category} category.`} />
            </Helmet>
            <div className="container my-5">
                 <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="mb-4">
                            <Link to="/directory" className="btn btn-outline-secondary">
                                <i className="bi bi-arrow-left me-2"></i>Back to Directory
                            </Link>
                        </div>
                        <div className="card shadow-lg border-0">
                            <div className="card-body p-md-5">
                                <div className="row align-items-center">
                                    <div className="col-md-4 text-center">
                                        <img 
                                            src={profile.photoURL || 'https://via.placeholder.com/200'} 
                                            alt={`${profile.name}`} 
                                            className="img-fluid rounded-circle mb-3" 
                                            style={{ width: '200px', height: '200px', objectFit: 'cover', border: '5px solid #f8f9fa' }}
                                        />
                                        <h2 className="fw-bold">{profile.name}</h2>
                                        <p className="text-muted fs-5">{profile.category}</p>
                                    </div>
                                    <div className="col-md-8">
                                        <h4 className="border-bottom pb-2 mb-3">Profile Details</h4>
                                        <p className="lead">{profile.description}</p>
                                        <ul className="list-group list-group-flush mt-4">
                                            {profile.email && (
                                                <li className="list-group-item d-flex align-items-center">
                                                    <i className="bi bi-envelope-fill text-primary me-3 fs-4"></i>
                                                    <a href={`mailto:${profile.email}`}>{profile.email}</a>
                                                </li>
                                            )}
                                            {profile.phone && (
                                                <li className="list-group-item d-flex align-items-center">
                                                    <i className="bi bi-telephone-fill text-primary me-3 fs-4"></i>
                                                    <span>{profile.phone}</span>
                                                </li>
                                            )}
                                            {profile.address && (
                                                 <li className="list-group-item d-flex align-items-center">
                                                    <i className="bi bi-geo-alt-fill text-primary me-3 fs-4"></i>
                                                    <span>{profile.address}</span>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProfileDetailPage;